/// <reference path="callCenter.module.ts" />
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.CallCenter {

  class ServiceDescriptionModalController {
    modalData: Array<Object>;
    serviceData: Array<Object>;
    firstNameData: Array<Object>;
    lastNameData: Array<Object>;

    static $inject = ["service", "$mdDialog"];
    public currentPane: Object;
    public paneCtrl: Object;
    public mdDialog: ng.material.IDialogService;

    protected serviceDescription: string;
    protected serviceShortcut: string;
    protected serviceDisplayName: string;

    constructor(service: any, $mdDialog: ng.material.IDialogService) {
      this.mdDialog = $mdDialog;

      if (service.shortcut && service.description && service.displayName) {
        this.serviceDescription = service.description;
        this.serviceShortcut = service.shortcut;
        this.serviceDisplayName = service.displayName;
      }
    }

    closeModal = () => {
      this.mdDialog.cancel();
    }
  }


  angular.module("meevo.plugins.callCenter")
    .controller("meevo.plugins.callCenter.serviceDescriptionModalController", ServiceDescriptionModalController);
}
